import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import main from 'pages/NewAuth/main.module.scss';
import { InputText, Button } from 'primereact';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import axios from 'axios/axios';
import { useForm } from 'react-hook-form';

export default function SocialConnect() {
  const navigate = useNavigate();
  let { newAuthFlowUserDetails } = useSelector(state => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: newAuthFlowUserDetails?.email || '',
    },
  });
  const onSubmit = async form => {
    setIsLoading(true);
    try {
      let { response } = await axios.get(`/auth/checkUserByEmail?email=${form.email}`);
      newAuthFlowUserDetails['email'] = form.email;
      dispatch({ type: 'addNewAuthFlowUserDetails', payload: newAuthFlowUserDetails });
      navigate(response ? '/auth/login' : '/auth/signup/username');
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={main.container}>
      <div className={main.main}>
        <div className="mobileHeader">
          <div className="leftSide">
            <i className="pi pi-arrow-left backIcon" onClick={() => navigate('/')} />
          </div>
          <div className="rightSide">
            <img src="/assets/icons/logo_plain.png" alt="logo" height="30px" />
          </div>
        </div>
        <img src="/assets/banners/socialconnect.png" alt="banner" className={main.banner} />
        <div className={styles.start}>
          <div className={main.title}>Connect your Accounts</div>
          <div className={styles.desc}>
            To connect your <span>{newAuthFlowUserDetails?.provider} account</span>, sign in or
            create a Beyond account using your email.
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            <span className={`p-input-icon-left ${styles.inputField}`}>
              <span className={styles.tag}>Email</span>
              <InputText
                id="email"
                type="email"
                className={errors.email ? `${styles.emailField} p-error` : styles.emailField}
                placeholder="i.e. example@mail.com"
                {...register('email')}
              />
              {errors.email && (
                <span className={`p-error ${styles.errorClass}`}>{errors.email.message}</span>
              )}
            </span>
            <div className={styles.buttons}>
              <div className={styles.resendButtonSection}>
                <img src="/assets/icons/info_blue.png" alt="info_blue" />
                <p>
                  Your <span>{newAuthFlowUserDetails?.provider} account</span> will be securely
                  linked to your Beyond account.
                </p>
              </div>
              <Button loading={isLoading} label="Continue" className={styles.continueButton} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
